import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { useCreateDivision, useRetrieveDivisionsBySeasonId, } from "../api/DivisionApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { DivisionForm } from "./DivisionForm";
export var CreateDivision = function () {
    var seasonId = useNumericParams().seasonId;
    var navigate = useNavigate();
    var _a = useRetrieveDivisionsBySeasonId({
        seasonId: seasonId,
        enabled: !!seasonId,
    }), _b = _a.data, divisions = _b === void 0 ? [] : _b, divisionsLoading = _a.isLoading;
    var mutation = useCreateDivision({
        onMutate: function () { },
        onSuccess: function (data) {
            var division = data.data;
            navigate("/seasons/".concat(division.season, "/"));
        },
        onError: function () { },
    });
    if (!seasonId) {
        return _jsx(ErrorView, { error: new Error("Missing season id") });
    }
    if (mutation.isLoading || divisionsLoading) {
        return _jsx(Loading, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to create division. Please try again.", onClose: function () { } }), _jsx(DivisionForm, { onSubmit: function (data) { return mutation.mutate(data); }, seasonId: seasonId, existingDivisions: divisions })] }));
};
